import { render, staticRenderFns } from "./EduDept.vue?vue&type=template&id=d62581f0&scoped=true"
import script from "./EduDept.vue?vue&type=script&lang=js"
export * from "./EduDept.vue?vue&type=script&lang=js"
import style0 from "./EduDept.vue?vue&type=style&index=0&id=d62581f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62581f0",
  null
  
)

export default component.exports